export default "__VITE_ASSET__TmUC5YJ2__"